import styled from 'styled-components'
import { color } from '../../../GlobalStyle'
import { breakpoints } from '../../../MediasQueries'

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  label {
    font-size: 12px;
    white-space: nowrap;
  }

  ${(props) =>
    props.login
      ? `
flex-grow:1;
`
      : null}
`
export const Input = styled.input`
  border: 1px solid #ced4da;
  border-radius: 3px;
  height: 30px;
  color: ${({ theme }) => theme.primary};
  @media (max-width: ${breakpoints.md}) {
    height: 35px;
  }
  height: ${(props) => props.height}!important;
  width: 100%;
  width: ${(props) => props.width};
  padding-left: 1vh;
  margin: ${(props) => props.margin};
  &:focus {
    outline-color: ${color.brand};
  }
  ::placeholder {
    color: #565656;
  }
  &:disabled {
    background: ${(props) =>
      !props.view
        ? props.theme.title == 'light'
          ? 'rgba(0,0,0,0.1)'
          : 'rgba(255,255,255,0.1)'
        : null};
    ::placeholder {
      opacity: ${(props) => (!props.view ? '0.5' : null)};
    }
  }

  ${(props) =>
    props.login
      ? `

      &:focus {
        outline: none;
      }
  height:33px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
 border-radius:0px 4px 4px 0px !important;



  
}
`
      : null}
`
